import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { toast } from 'sonner';
import { Check, X, Trash2, Instagram } from 'lucide-react';

export default function AdminAmbassadorApplications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/admin/ambassador-applications'); setApps(data.applications || []); }
    catch { toast.error('Failed to load'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const approve = async (a) => {
    try { await api.post(`/admin/ambassador-applications/${a.id}/approve`); toast.success('Approved — create their profile from Ambassadors page'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };
  const reject = async (a) => {
    try { await api.post(`/admin/ambassador-applications/${a.id}/reject`); toast.success('Rejected'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Delete application from ${a.name}?`)) return;
    try { await api.delete(`/admin/ambassador-applications/${a.id}`); toast.success('Deleted'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="space-y-5" data-testid="admin-amb-apps">
      <div className="h-panel-thin p-6">
        <div className="h-eyebrow">Ambassadors</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Applications</div>
        <p className="text-sm opacity-85 mt-1" style={{ color: 'var(--heritage-plum)' }}>Everyone who applied via the public form. Approve then create their profile from the Ambassadors page.</p>
      </div>
      {loading && <div className="h-eyebrow">Loading…</div>}
      {!loading && apps.length === 0 && <Panel className="p-8 text-center"><div className="h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>No applications yet</div></Panel>}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {apps.map((a) => (
          <Panel key={a.id} className="p-4" data-testid={`amb-app-${a.email}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{a.name}</div>
                <div className="text-xs opacity-75" style={{ color: 'var(--heritage-plum)' }}>{a.email}{a.phone ? ` · ${a.phone}` : ''}</div>
                <div className="text-xs opacity-75 mt-1" style={{ color: 'var(--heritage-plum)' }}>
                  {a.instagram && <span className="mr-3"><Instagram size={10} className="inline mr-1" />{a.instagram}</span>}
                  {a.tiktok && <span className="mr-3">TikTok: {a.tiktok}</span>}
                  {a.followers && <span>{a.followers} followers</span>}
                </div>
                {a.why && <p className="text-sm mt-2 opacity-90" style={{ color: 'var(--heritage-plum)' }}>{a.why}</p>}
                <div className="text-[10px] opacity-60 mt-2" style={{ color: 'var(--heritage-plum)' }}>Received {new Date(a.created_at).toLocaleString('en-NZ')}</div>
              </div>
              <span className="h-chip text-[9px]" style={{ background: a.status === 'approved' ? 'rgba(91,110,44,0.18)' : a.status === 'rejected' ? 'rgba(154,44,44,0.15)' : 'rgba(75,24,56,0.08)', borderColor: 'transparent', color: 'var(--heritage-plum)' }}>{(a.status || 'pending').toUpperCase()}</span>
            </div>
            <div className="flex items-center justify-end gap-2 mt-3 pt-3 border-t" style={{ borderColor: 'rgba(75,24,56,0.15)' }}>
              {a.status !== 'approved' && <button onClick={() => approve(a)} className="h-btn text-xs" data-testid={`amb-app-approve-${a.email}`}><Check size={12} className="mr-1" /> Approve</button>}
              {a.status !== 'rejected' && <button onClick={() => reject(a)} className="h-btn-outline text-xs" data-testid={`amb-app-reject-${a.email}`}><X size={12} className="mr-1" /> Reject</button>}
              <button onClick={() => remove(a)} className="text-xs inline-flex items-center gap-1 opacity-80 hover:opacity-100 px-2 py-1" style={{ color: '#9A2C2C' }} data-testid={`amb-app-delete-${a.email}`}><Trash2 size={12} /></button>
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
